import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function category(slug:string, page:number, sort: any): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('category')
    .setMethod('POST')
    .setProps([{slug: slug, page: page, sort: sort}])
    .send();
}
